// @flow
import { useJsonForms, ctxToLayoutProps } from '@jsonforms/react';
import useEnabled from './useEnabled';

export const getLayoutProps = (ctx, props) => {
    return ctxToLayoutProps(ctx, props);
};

const useLayoutProps = (props: $FixMe) => {
    const ctx = useJsonForms();
    const layoutProps = getLayoutProps(ctx, props);

    const enabled = useEnabled({
        enabled: layoutProps.enabled,
        uischema: layoutProps.uischema
    });

    return {
        ...layoutProps,
        enabled
    };
};

export default useLayoutProps;
